import { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import {jwtDecode} from "jwt-decode";
import Swal from "sweetalert2"
import "../../assets/css/category.css";

const phoneNumber = "+800-123-4567 6587";
const initialAddress = "Beverley, New York 224 USA"; 



let socialList = [
    //{ iconName: 'fa-brands fa-instagram', siteLink: '#', color: '#f834f1ff' },
    //{ iconName: 'fa-brands fa-facebook', siteLink: '#', color: '#1DA1F2' },
    { iconName: 'fa-brands fa-youtube', siteLink: 'https://youtu.be/x5YOxuTsuw4?si=LVzlrX2ys4-qlTDb', color: '#fd0a0aff' }
];

const Header = () => {
    const [menuToggle, setMenuToggle] = useState(false);
    const [socialToggle, setSocialToggle] = useState(false);
    const [headerFixed, setHeaderFixed] = useState(false);
    const navigate = useNavigate();
    const [currentAddress, setCurrentAddress] = useState(""); 

    const [user, setUser] = useState(null);
    const isTutor = user?.role === "tutor";
    const [hover, setHover] = useState(false);


    const closeMenu = () => {
    setMenuToggle(false);
    setSocialToggle(false);
};


    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            setUser(null);
            return;
        }

        try {
            const decoded = jwtDecode(token);

            setUser({
                id: decoded.id,
                role: decoded.role,
                email: decoded.email
            });
        } catch (error) {
            console.log("Invalid token:", error);
            localStorage.removeItem("token");
            setUser(null);
        }
    }, []);

    const handleLogout = () => {
  localStorage.removeItem("token");
  setUser(null);
 
  Swal.fire({
    icon: "success",
    title: "Logged Out",
    text: "Redirecting to Home...",
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    width: 360,
    heightAuto: false,
    didClose: () => {
      navigate("/");
    }
  });
};

    const chalkFont = {
        fontFamily: "'Freckle Face', cursive",
        fontSize: "20px",
        letterSpacing: "2px",
    };

    const homeColor = { color: "#d6cd20ff" };
    const singingColor = { color: "#FF6F61" };
    const danceColor = { color: "#F7E96E" };
    const paintingColor = { color: "#87CEEB" };
    const craftColor = { color: "#f73be7ff" };
    const morecolor = { color: "#f5800bff" };

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(async (pos) => {
            const lat = pos.coords.latitude;
            const lon = pos.coords.longitude;

            try {
                const res = await fetch(
                    `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=en`
                );
                const data = await res.json();

                const area = data.locality || data.localityInfo?.administrative?.[2]?.name;
                const city = data.city;
                const state = data.principalSubdivision;
                const country = data.countryName;

                setCurrentAddress(`${area}, ${city}, ${state}, ${country}`);
            } catch (error) {
                console.error("Location error:", error);
                setCurrentAddress("Unable to detect location");
            }
        },
        () => {
            setCurrentAddress("Hyderabad");
        });
    }, []);

    const mobileIconStyle = {
        color: '#070405ff',
        fontSize: '24px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: '0 8px',
    };

    const mobileIconContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        height: '100%',
    };

    return (


        <>
                <style>{`
            .kks-logo{
                width:204px;
                height:50px;
 
            }
            @media (max-width:765px){
            .kks-logo{
            width:204px;}}`}
        </style>
        <header className={`header-section ${headerFixed ? "header-fixed fadeInUp" : ""}`}>
            {/* Header Top */}
{/* Header Top */}
<div className="header-top" style={{ display: 'block' }}>
    <div className="container">
        <div className="header-top-area d-flex justify-content-between align-items-center">
            <ul className="lab-ul left d-flex" style={{ color: "orange", margin: 0, padding: 0 }}>
                <li>
                    <i className="icofont-location-pin"></i> {currentAddress}
                </li>
            </ul>

            {/* Change: Added 'd-none d-lg-flex' to hide on mobile/tablet and show on desktop
            <ul className="lab-ul social-icons d-none d-lg-flex align-items-center" style={{ margin: 0, padding: 0, gap: "10px" }}>
                <li><p style={{ color: "orange", margin: 0 }}>Find us on :</p></li>
                {socialList.map((val, i) => (
                   <li key={i}>
  <a
    href={val.siteLink}
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: val.color }}
  >
    <i className={val.iconName}></i>
  </a>
</li>

                ))}
            </ul> */}
        </div>
    </div>
</div>

            {/* Header Bottom */}
            <div className="header-bottom">
                <div className="container">
                    <div className="header-wrapper d-flex justify-content-between align-items-center">
                            <div className="logO" width="100px">
                            {isTutor ? (
                                <img
                                src="/assets/images/logo/NewLogo.png"
                                alt="logo"
                                className="kks-logo"
                                style={{ cursor: "default" }}
                                />
                            ) : (
                                <Link to="/">
                                <img
                                    src="/assets/images/logo/NewLogo.png"
                                    alt="logo"
                                    className="kks-logo"
                                />
                                </Link>
                            )}
                            </div>

                        {/* Menu Area */}
                        <div className="menu-area" style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                            <div className="menu" style={{ width: '100%', display: 'flex', justifyContent: 'right' }}>
                                        <ul
                                        className={`lab-ul custom-hide-mobile ${menuToggle ? "active" : ""}`}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "7px",
                                        }}
                                        >

                                        {/* Hide navigation for tutor */}
                                        {!isTutor && (
                                        <>
                                        <li>
                                            <NavLink to="/"   onClick={closeMenu} style={{ ...chalkFont, ...homeColor }}>
                                            Home
                                            </NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/tutors/Music"     onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} onClick={closeMenu} style={({isActive})=>({ ...chalkFont, ...singingColor, backgroundColor:isActive ? "#f1e5de" : "transparent"})}>
                                            Music
                                            </NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/tutors/Dance" onClick={closeMenu}    onMouseEnter={() => setHover(true)}
  onMouseLeave={() => setHover(false)} style={({isActive})=>({ ...chalkFont, ...danceColor, backgroundColor:isActive ? "#ddd5dd" : "transparent"})}>
                                            Dance
                                            </NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/tutors/Painting%20and%20Drawing" onClick={closeMenu}   onMouseEnter={() => setHover(true)}
  onMouseLeave={() => setHover(false)}  style={({isActive})=>({ ...chalkFont, ...paintingColor, backgroundColor:isActive ? "#f3efef" : "transparent"})}>
                                            Painting & Drawing
                                            </NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/tutors/Crafts" onClick={closeMenu}   onMouseEnter={() => setHover(true)}
  onMouseLeave={() => setHover(false)}  style={({isActive})=>({ ...chalkFont, ...craftColor, backgroundColor:isActive ? "#f1e1f0" : "transparent"})}>
                                            Crafts
                                            </NavLink>
                                        </li>

                                        <li>
                                            <NavLink to="/morearts" onClick={closeMenu}   onMouseEnter={() => setHover(true)}
  onMouseLeave={() => setHover(false)} style={({isActive})=>({ ...chalkFont, ...morecolor, backgroundColor:isActive ? "#c3c2a4" : "transparent"})}>
                                            More
                                            </NavLink>
                                        </li>
                                        </>
                                        )}

                                        {/* Profile */}
                                        {user?.role === "student" && (
                                        <li>
                                            <NavLink to="/student-profile" onClick={closeMenu} style={{ ...chalkFont, color: "orange" }}>
                                            My Profile
                                            </NavLink>
                                        </li>
                                        )}

                                        {user?.role === "tutor" && (
                                        <li>
                                            <NavLink to="/tutor-profile" onClick={closeMenu} style={{ ...chalkFont, color: "orange" }}>
                                            My Profile
                                            </NavLink>
                                        </li>
                                        )}

                                        {/* Logout always visible */}
                                        <li>
                                        {!user ? (
                                            <Link
                                            to="/login"
                                            style={{
                                                backgroundColor: "white",
                                                borderRadius: "10px",
                                                padding: "5px 15px",
                                                color: "black",
                                            }}
                                            >
                                            Login
                                            </Link>
                                        ) : (
                                            <button
                                            onClick={handleLogout}
                                            style={{
                                                backgroundColor: "#fc0909",
                                                borderRadius: "10px",
                                                padding: "5px 15px",
                                                color: "white",
                                            }}
                                            >
                                            Logout
                                            </button>
                                        )}
                                        </li>

                                        </ul>   
                            </div>
                        </div>

                        {/* Consolidated Mobile Icons */}
                        <div className="header-icon-links custom-hide-desktop custom-show-mobile-flex" style={mobileIconContainerStyle}>

                       

                    {!isTutor && (
<div 
  onClick={() => setMenuToggle(!menuToggle)} 
  
    
    style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '25px',
        height: '18px',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
    }}
>
    <span style={{
        display: 'block',
        height: '2px',
        width: '100%',
         backgroundColor: '#e38912ff',
        transition: '0.3s',
        transform: menuToggle ? 'translateY(8px) rotate(45deg)' : 'none'
    }}></span>
    <span style={{
        display: 'block',
        height: '2px',
        width: '100%',
          backgroundColor: '#e38912ff',
        transition: '0.3s',
        opacity: menuToggle ? 0 : 1
    }}></span>
    <span style={{
        display: 'block',
        height: '2px',
        width: '100%',
         backgroundColor: '#e38912ff',
        transition: '0.3s',
        transform: menuToggle ? 'translateY(-8px) rotate(-45deg)' : 'none'
    }}></span>
</div>
)}

                            <div>
                                {!user ? (
                                    <Link to="/login" style={{ backgroundColor: '#f0e8e6ff', border: 'none', borderRadius: '15px', fontWeight: 'bold', padding: '5px 15px', textDecoration: 'none', color: 'black' }}>
                                        <span>LOGIN</span>
                                    </Link>
                                ) : (
                                    <a onClick={handleLogout} className="logout-icon-link" style={{ ...mobileIconStyle, color: '#FF0000', borderRadius: '15px' }}>
                              <i className="fa-solid fa-power-off"></i>
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        </>
    );
};

export default Header;